module.exports = "<div>请你耐心等待</div> <div style=text-align:center>正在打印第<span style=color:red>{{index}}</span>张发票</div> <div style=text-align:left>发票种类：{{invTypeName}}</div> <div style=text-align:left>发票代码：{{invoiceCode}}</div> <div style=text-align:left>发票号码：{{invoiceNumber}}</div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/outputManage/billManage/openedInvoice/view/waitMessage.html
// module id = ABI6
// module chunks = 0